import Toast, { TOAST_TRANSITION_DURATION } from './Toast';
import { showWithTransition } from '../../utils/show';
export default function (config) {
    return showWithTransition({
        Component: Toast,
        transitionDuration: TOAST_TRANSITION_DURATION,
        autoClose: true,
        props: config,
        contexts: config.contexts,
    });
}
